module.exports = __webpack_public_path__ + "img/72_27.b8fd1a27.png";